// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"b2831afc","411":"988efd06","564":"9fb5dbd5","890":"e771baa0","954":"f9819530"}[chunkId] + ".chunk.js";
};